import { useEffect, useState } from 'react';
import { useToasterState } from './useToasterState';
import { useAppDispatch, useAppSelector } from '../../../Store/store';
import { TOASTER_STATE } from '../../../Model/Enums';
import { changeToasterState, toasterStateSelector } from '../../../Store/layoutSlice';

export const useToasterBehavior = () => {
  const [visible, setVisible] = useState(false);
  const toasterState = useAppSelector(toasterStateSelector);
  const dispatch = useAppDispatch();
  const { state } = useToasterState();

  useEffect(() => {
    if (toasterState && toasterState !== TOASTER_STATE.EMPTY) {
      setVisible(() => true);
      const timer = setTimeout(() => {
        setVisible(() => false);
        dispatch(changeToasterState(TOASTER_STATE.EMPTY));
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [toasterState, dispatch]);

  const onChange = () => {
    setVisible(() => !visible);
  };

  return { visible, state: state[toasterState], onChange };
};
